import { Injectable } from '@angular/core';
import {Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouteReuseHelperService {

    public shouldReFilter : Subject<boolean> = new Subject<boolean>();

  constructor() { }
}
